import React from 'react';
import {useCallback, useEffect, useState} from "react";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import {debounce} from "lodash"
import store from "../store";
import graphsService from "./graphs/graph-service";

let moment = require('moment');

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

function DatesRange() {
  const [min_range, setMinRange] = useState(0);
  const [max_range, setMaxRange] = useState(100);
  const [current_value, setCurrentValue] = useState([]);
  const [start_date_label, setStartDateLabel] = useState([]);
  const [end_date_label, setEndDateLabel] = useState([]);

  useEffect(() => {
    setStartDateLabel(store.start_date);
    setEndDateLabel(store.day_before_end_date);

    const past_limit = moment().subtract(store.min_day_limit, 'days').format('YYYY-MM-DD');
    let range = calculateDateRange(past_limit, store.end_date);

    setMaxRange(Math.abs(range));
    setCurrentValue([Math.abs(range) - store.default_days_behind, Math.abs(range) - 1]);

    // debounceCl(store.start_date, store.end_date);
  }, []);

  const calculateDateRange = (startDateStr, endDateStr) => {
    let startDate = moment(startDateStr, 'YYYY-MM-DD');
    let endDate = moment(endDateStr, 'YYYY-MM-DD');

    return endDate.diff(startDate, 'days');
  }

  const onDateChange = ([newStartDate, newEndDate]) => {
    let start_formatted = moment(store.start_date, 'YYYY-MM-DD').add(newStartDate - (store.min_day_limit - store.default_days_behind), 'days').format('YYYY-MM-DD');
    let end_formatted = moment(store.end_date, 'YYYY-MM-DD').subtract(max_range - newEndDate, 'days').format('YYYY-MM-DD');

    setCurrentValue([newStartDate, newEndDate]);
    setStartDateLabel(start_formatted);
    setEndDateLabel(end_formatted);

    store.setModifiedStartAndEndDate(start_formatted, end_formatted);

    debounceCl(start_formatted, end_formatted);
  };

  const debounceCl = useCallback(
    debounce((start_formatted, end_formatted) => graphsService.fetchAllDateSlideListeners(start_formatted, end_formatted), 1500), []
  );

  const tipFormatter = (value) => {
    let [min, max] = current_value;
    if (min == value) {
      return <div className="p-1 text-center">{start_date_label}</div>;
    } else if (max == value) {
      return <div>{end_date_label}</div>;
    } else {
      return (<></>);
    }
  }

  return (
    <div className="flex flex-row space-x-10 m-auto mt-4 text-white md:w-1/2 2xl:w-1/2">
      <span className='w-1/6'>{start_date_label}</span>
      <Range
        tipFormatter={tipFormatter}
        onChange={onDateChange} allowCross={false} min={min_range} max={max_range}
        value={current_value}/>
      <span className='w-1/6'>{end_date_label}</span>
    </div>
  );
}

// export default observer(DatesRange);
export default DatesRange;
